module.exports = __webpack_public_path__ + "static/portrait_oren-5934b25143ea3c9a0c21a4cb964b1b4f.jpg";